export function getCountyInfo() {
  const lang = (
    (navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language) || ''
  )?.split('-');
  try {
    let regionNames = new Intl.DisplayNames([lang[0]], { type: 'region' });
    return { country: regionNames.of(lang[1]), countryCode: lang[1] };
  } catch (e) {
    console.error(e);
    return { country: 'PT', countryCode: 'Portugal' };
  }
}
